import { gql } from "@apollo/client";

export const ALL_CHATGPT_TEMPLATES = gql`
  query AllChatGptTemplates {
    AllChatGptTemplates {
      chatGPTtemplates {
        id
        updatedAt
        createdAt
        template
        module
        name
        description
        originalTemplate
        modelId
        model {
          id
          name
          displayName
          provider {
            id
            name
            displayName
          }
        }
      }
      count
    }
  }
`;

export const SAVE_CHATGPT_TEMPLATES = gql`
  mutation SaveChatgptTemplates($settingDetails: settingDetailsForChatGPTInput!) {
    SaveChatgptTemplates(settingDetails: $settingDetails) {
      message
      status
    }
  }
`;

export const DELETE_CHATGPT_TEMPLATE = gql`
  mutation DeleteChatgptTemplate($id: String!) {
    DeleteChatgptTemplate(id: $id) {
      message
      status
    }
  }
`;

export const ALL_LLM_PROVIDERS = gql`
  query AllLlmProviders {
    allLlmProviders {
      id
      name
      displayName
    }
  }
`;

export const ALL_LLM_MODELS = gql`
  query AllLlmModels($providerId: String) {
    allLlmModels(providerId: $providerId) {
      id
      name
      displayName
      provider {
        id
      }
    }
  }
`;
